/**
 * Copyright 2026 Bluecircle Technologies Pvt Limited. All rights reserved.
 *
 * This software and its source code are the proprietary and confidential
 * intellectual property of Bluecircle Technologies Pvt Limited. Unauthorized
 * copying, reproduction, distribution, modification, public display, or use
 * of this software, in whole or in part, is strictly prohibited without the
 * prior written permission of Bluecircle Technologies Pvt Limited.
 *
 * Portions derived from Grist (Copyright Grist Labs), used under the Apache
 * License, Version 2.0. See the NOTICE file for details.
 */

import { testId, theme } from "app/client/ui2018/cssVars";
import { icon } from "app/client/ui2018/icons";

import { styled } from "grainjs";

// TODO: Update and move koForm draggableList here.

// Drag icon for use in koForm draggableList.
export const cssDragger = styled((...args: any[]) => icon("DragDrop", testId("dragger"), ...args), `
  --icon-color: ${theme.controlSecondaryFg};
  visibility: hidden;
  align-self: center;
  flex-shrink: 0;
  .kf_draggable:hover & {
    visibility: visible;
  }
`);
